var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6133 16.3477L41.8984 12.7148L38.2656 0H12.8359C9.82639 0 7.38672 2.43968 7.38672 5.44922V56.5508C7.38672 59.5603 9.82639 62 12.8359 62H49.1641C52.1736 62 54.6133 59.5603 54.6133 56.5508V16.3477Z",
    fill: "#4086F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6133 16.3477V56.5508C54.6133 59.5603 52.1736 62 49.1641 62H31V0H38.2656L41.8984 12.7148L54.6133 16.3477Z",
    fill: "#4175DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6133 16.3477H41.8984C39.9004 16.3477 38.2656 14.7129 38.2656 12.7148V0C38.7379 0 39.2102 0.181641 39.537 0.545043L54.0682 15.0763C54.4316 15.4031 54.6133 15.8754 54.6133 16.3477Z",
    fill: "#80AEF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8984 29.1836H20.1016C19.0976 29.1836 18.2852 28.3712 18.2852 27.3672C18.2852 26.3632 19.0976 25.5508 20.1016 25.5508H41.8984C42.9024 25.5508 43.7148 26.3632 43.7148 27.3672C43.7148 28.3712 42.9024 29.1836 41.8984 29.1836Z",
    fill: "#FFF5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8984 36.4492H20.1016C19.0976 36.4492 18.2852 35.6368 18.2852 34.6328C18.2852 33.6288 19.0976 32.8164 20.1016 32.8164H41.8984C42.9024 32.8164 43.7148 33.6288 43.7148 34.6328C43.7148 35.6368 42.9024 36.4492 41.8984 36.4492Z",
    fill: "#FFF5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8984 43.7148H20.1016C19.0976 43.7148 18.2852 42.9024 18.2852 41.8984C18.2852 40.8944 19.0976 40.082 20.1016 40.082H41.8984C42.9024 40.082 43.7148 40.8944 43.7148 41.8984C43.7148 42.9024 42.9024 43.7148 41.8984 43.7148Z",
    fill: "#FFF5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6328 50.9805H20.1016C19.0976 50.9805 18.2852 50.1681 18.2852 49.1641C18.2852 48.1601 19.0976 47.3477 20.1016 47.3477H34.6328C35.6368 47.3477 36.4492 48.1601 36.4492 49.1641C36.4492 50.1681 35.6368 50.9805 34.6328 50.9805Z",
    fill: "#FFF5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 50.9805H34.6328C35.6368 50.9805 36.4492 50.1681 36.4492 49.1641C36.4492 48.1601 35.6368 47.3477 34.6328 47.3477H31V50.9805Z",
    fill: "#E3E7EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43.7148H41.8984C42.9024 43.7148 43.7148 42.9024 43.7148 41.8984C43.7148 40.8944 42.9024 40.082 41.8984 40.082H31V43.7148Z",
    fill: "#E3E7EA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36.4492H41.8984C42.9024 36.4492 43.7148 35.6368 43.7148 34.6328C43.7148 33.6288 42.9024 32.8164 41.8984 32.8164H31V36.4492Z",
    fill: "#E3E7EA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31 29.1836H41.8984C42.9024 29.1836 43.7148 28.3712 43.7148 27.3672C43.7148 26.3632 42.9024 25.5508 41.8984 25.5508H31V29.1836Z",
    fill: "#E3E7EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsImg);
export default __webpack_public_path__ + "static/media/docsImg.f6e18e6d6d3ecf29149aef2a6e436186.svg";
export { ForwardRef as ReactComponent };